import { render, staticRenderFns } from "./bring.vue?vue&type=template&id=29dc1d1c&scoped=true&"
import script from "./bring.vue?vue&type=script&lang=js&"
export * from "./bring.vue?vue&type=script&lang=js&"
import style0 from "./bring.vue?vue&type=style&index=0&id=29dc1d1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc1d1c",
  null
  
)

export default component.exports